import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { CoreModule } from 'app/core/core.module';
import { CompanyAuditService } from './services/company-audit.service';
import { COMPANY_AUDIT_ROUTES } from './company-audit-routing.module';
import { CompanyAuditAddComponent } from './component/company-audit-add/company-audit-add.component';
import { CompanyAuditUpdateComponent } from './component/company-audit-update/company-audit-update.component';
import { CompanyAuditListComponent } from './component/company-audit-list/company-audit-list.component';
import { CompanyAuditDetailsComponent } from './component/company-audit-details/company-audit-details.component';
import { CompanyAuditModuleComponent } from './component/company-audit-module/company-audit-module.component';
import { DynamicFormComponent } from './component/dynamic-form/dynamic-form.component';
import { QuestionService } from './services/question.service';
import { DynamicFormQuestionComponent } from './component/dynamic-form-question/dynamic-form-question.component';
import { CompanyAuditModuleViewComponent } from './component/company-audit-module-view/company-audit-module-view.component';
import { DocumentComponent } from './component/document/document.component';
import { RequestExternalAuditComponent } from './component/request-external-audit/request-external-audit.component';


@NgModule({
    imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(COMPANY_AUDIT_ROUTES)
    ],
    declarations: [
        CompanyAuditAddComponent,
        CompanyAuditUpdateComponent,
        CompanyAuditListComponent,
        CompanyAuditDetailsComponent,
        CompanyAuditModuleComponent,
        DynamicFormComponent,
        DynamicFormQuestionComponent,
        DocumentComponent,
        CompanyAuditModuleViewComponent,
        RequestExternalAuditComponent

    ],
    providers: [
        CompanyAuditService,
        QuestionService
    ]
})
export class CompanyAuditModule { }
